import React from 'react';
import './Hero.css';
import RocketManAnimation from './RocketManAnimation';


function Hero() {
  return (
    <div id="fh5co-hero-wrapper">
      <div className="container fh5co-hero-inner">
        <div className="row">
          <div className="col-md-6">
              <RocketManAnimation />  
          </div>
          <div className="col-md-6">
          <div className="hero-content">
            <h1 className="" data-wow-delay="0.4s">
              ROCKET POWER TO EVERYONE
            </h1>
            <p className="animated fadeIn wow" data-wow-delay="0.67s">
              We set focus on great user journeys to simplify everyday life for our customers. The Tripletex playbook describes how we work and what we believe in. We believe that culture eats process for breakfast and to succeed we create a culture that empowers our employees.
            </p>
            <div className="animated fadeIn wow" data-wow-delay="0.7s">
              <p>Read more about it in the:</p>
              <ol>
                <li>Core principles</li>
                <li>Core team</li>
                <li>Core workflow</li>
              </ol>
            </div>
            </div>
            {/* <button 
              className="btn btn-md download-btn-first wow fadeInRight animated hero-button" 
              data-wow-delay="0.85s" 
              onClick={() => document.getElementById('core-principles').scrollIntoView({behavior: 'smooth'})}
            >
              Core principles
            </button> */}
          </div>
        </div>
      </div>
      <div>
     
    </div>
    </div>
  );
}

export default Hero;
